import { render } from "./Placements.vue?vue&type=template&id=4171d886&scoped=true"
import script from "./Placements.vue?vue&type=script&lang=js"
export * from "./Placements.vue?vue&type=script&lang=js"

import "./Placements.vue?vue&type=style&index=0&id=4171d886&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4171d886"]])

export default __exports__